import { utilityFns } from "./utility-functions";

export const testMandatoriesFns = {
  aboutYou: (profile) => {
    const { personal, address, pep } = profile;
    const now = new Date();
    const d = new Date(profile.dateofbirth);
    const ExpMs = (365 * 18 + 5) * 86400 * 1000;
    return !!(
      utilityFns.emptyString(personal.title) &&
      (pep.pep ? (!!pep.details ? true : false) : true) &&
      utilityFns.emptyString(personal?.firstName) &&
      utilityFns.emptyString(personal?.lastName) &&
      utilityFns.emptyString(address?.street) &&
      utilityFns.emptyString(profile.phone) &&
      utilityFns.emptyString(address?.city) &&
      utilityFns.validEnglishTextAndNumber(personal?.firstName) &&
      utilityFns.validEnglishTextAndNumber(personal?.lastName) &&
      utilityFns.validEnglishTextAndNumber(address?.city) &&
      !!address?.country &&
      !!personal?.citizenship &&
      !!profile.dateofbirth &&
      new Date("1903", "01", "01").getTime() - 31 * 86400 * 1000 <
        d.getTime() &&
      now.getTime() - ExpMs > d.getTime()
    );
  },
  IDVerification: (profile, files) => {
    const now = new Date();
    const ExpAheadMs = 90 * 86400 * 1000;
    return !!(
      profile.idtype &&
      utilityFns.emptyString(profile.idnumber) &&
      utilityFns.validIDNumber(profile.idnumber) &&
      profile.idexpirydate !== undefined &&
      (!!profile.isexpiry
        ? now.getTime() + ExpAheadMs < new Date(profile.idexpirydate).getTime()
        : true) &&
      Object.keys(files).includes("photoID") &&
      Object.keys(files).includes("identity") &&
      Object.keys(files).includes("address")
    );
  },
  agreement: (state) => {
    return !!(
      testMandatoriesFns.aboutYou(state.profile) &&
      utilityFns.strToBoolean(state.profile.agreement1) &&
      utilityFns.strToBoolean(state.profile.agreement2) &&
      !!state.profile.signature
    );
  },
  businessDeal: (profile, limits) => {
    const rules = profile.agreement?.rules || [];

    return (
      Object.keys(limits || []).every((l) => {
        // console.log(l, limits[l].max, limits[l].min)
        return (
          parseInt(rules[l]) <= parseInt(limits[l].max) &&
          parseInt(rules[l]) >= parseInt(limits[l].min)
        );
      }) &&
      !!profile.accountType &&
      !!profile.software &&
      !!profile.softwareType &&
      !!profile.marketdataBundle &&
      !!profile.agreement.marketData.length
    );
  },
  hasOpenInquiries: (existingRequests) => {
    return existingRequests?.some(
      (request) =>
        request.type === "INQUIRY" &&
        (request.status === "OPEN" ||
          request.status === "INPROGRESS" ||
          request.status === "ONHOLD")
    );
  },
  findMissingFields: (profile) => {
    if (!profile) return [];
    
    const personal = profile.personal || {};
    const address = profile.address || {};
    const pep = profile.pep || {};
    
    const now = new Date();
    const d = profile.dateofbirth ? new Date(profile.dateofbirth) : null;
    const ExpMs = (365 * 18 + 5) * 86400 * 1000;
    
    const missingFields = [];
    
    if (!personal.title || !utilityFns.emptyString(personal.title)) 
      missingFields.push('title');
    
    if (pep.pep && !pep.details) 
      missingFields.push('pep details');
    
    if (!personal.firstName || !utilityFns.emptyString(personal.firstName)) 
      missingFields.push('firstName');
    
    if (!personal.lastName || !utilityFns.emptyString(personal.lastName)) 
      missingFields.push('lastName');
    
    if (!address.street || !utilityFns.emptyString(address.street)) 
      missingFields.push('street');
    
    if (!profile.phone || !utilityFns.emptyString(profile.phone)) 
      missingFields.push('phone');
    
    if (!address.city || !utilityFns.emptyString(address.city)) 
      missingFields.push('city');
    
    if (personal.firstName && !utilityFns.validEnglishTextAndNumber(personal.firstName)) 
      missingFields.push('invalid firstName format');
    
    if (personal.lastName && !utilityFns.validEnglishTextAndNumber(personal.lastName)) 
      missingFields.push('invalid lastName format');
    
    if (address.city && !utilityFns.validEnglishTextAndNumber(address.city)) 
      missingFields.push('invalid city format');
    
    if (!address.country) 
      missingFields.push('country');
    
    if (!personal.citizenship) 
      missingFields.push('citizenship');
    
    if (!profile.dateofbirth) 
      missingFields.push('dateofbirth');
    
    if (d && new Date("1903", "01", "01").getTime() - 31 * 86400 * 1000 >= d.getTime())
      missingFields.push('dateofbirth too early');
    
    if (d && now.getTime() - ExpMs <= d.getTime())
      missingFields.push('dateofbirth too recent (must be 18+ years)');
    
    return missingFields;
  },
};
